// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aIjo","type":"styles_type__26xQ4","choices":"styles_choices__2j0fx"};